<template>
  <standard-page title="Available Process Definitions" :definition="$t('provenance.availableProcessDefinitions')">
    <template v-slot:content>
      <data-table :api="api" :columns="columns" :row-click="view" :server-side="true" list-key="process_definitions" table-id="available_process" total-key="total" @ready="onReady" />
    </template>
  </standard-page>
</template>

<script>
import { mapGetters } from 'vuex';
import { apiMixin } from '@/utils/api-mixin';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'AvailableProcessDefinitions',
  mixins: [apiMixin('provenance')],
  data() {
    return {
      api: `${this.$provenance.defaults.baseURL}/provenance/registries/available_definitions`,
      columns: [
        { type: 'name' },
        { type: 'created' },
        { type: 'extrinsic' }
      ],
      table: null,
    };
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    onReady(table) {
      this.table = table;
      $('#main-table tbody').on('click', '.newprocess', function () {
        let entity = table.row($(this).parents('tr')).data();
        self.newProcess(entity);
      });
    },
    view(row) {
      this.$router.push({ name: 'available-process', params: { registryid: row.registry, definitionid: row.process_definition } });
    },

  }
}
);
</script>

<style scoped>
</style>
